import { API_URL } from "../../constants";
import * as httpNetworking from "../../httpNetworking";

const URL = API_URL + "/user";
const VERSION = 0;

export default async function deleteOwnAccount(): Promise<void> {
    const options: httpNetworking.DELETERequestConfig = {
        timeout: 50000
    };

    const response = (await httpNetworking.simpleDELETERequest(URL, options, VERSION)).data;
    return response;
}
